export default {
  "home": "ACCUEIL",
  "news": "NOUVELLES",
  "community": "COMMUNAUTÉ",
  "character": "PERSONNAGES",
  "world": "CADRE DU MONDE",
  "features": "FEATURES",
  "topUp": "TOP UP",
  "customerService": "SERVICE CLIENT",
  "download": "TÉLÉCHARGER",
  "moreDownload": "Plus de méthodes de téléchargement",
  "screenshot": "CAPTURE D'ÉCRAN",
  "video": "CINÉMATIQUE",
  "poster": "POSTER",
  "downloadGame": "TÉLÉCHARGER",
  "scan": "Scanner le code QR pour télécharger",
  "prev": "Précédent",
  "next": "Suivant",
  "moreNews": "INFORMATIONS",
  "latest": "DERNIER",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "Encore aucun contenu",
  "goPay": "ALLER MAINTENANT",
  "payGuide": "EN SAVOIR PLUS",
  "stayTurn": "Restez à l’affût !",
  "hero1": "Richard Cœur de Lion",
  "hero1_text": "Richard 1er, mieux connu sous le nom de Richard Cœur de Lion, fut couronné roi d'Angleterre le 6 juillet 1189. Il a une réputation de grand guerrier et de chef éclairé.",
  "hero1_skill1": "Roi des croisés",
  "hero1_skill2": "Garde royale",
  "hero1_skill3": "Cœur de Lion",
  "hero1_skill4": "Bonus d’énergie",
  "hero2": "Alexandre le Grand",
  "hero2_text": "Alexandre III de Macédoine, plus connu sous le nom d'Alexandre le Grand, fut le roi de l'ancien royaume grec de Macédoine. Alexandre s'était juré d'atteindre le bout du monde et la grande mer qui le borde et disputa pour ce faire d'innombrables guerres.",
  "hero2_skill1": "Le fils de Dieu",
  "hero2_skill2": "Compagnons",
  "hero2_skill3": "Marche solitaire",
  "hero2_skill4": "Phalange macédonienne",
  "hero3": "Mulan",
  "hero3_text": "Hua Mulan est une héroïne chinoise légendaire de la période des dynasties du Nord et du Sud (du 4e au 6e siècle). D'après la Balade de Mulan, celle-ci se déguisa en homme afin de remplacer son vieux père dans l'armée.",
  "hero3_skill1": "Tir puissant",
  "hero3_skill2": "L’Héroïne",
  "hero3_skill3": "Appel du devoir",
  "hero3_skill4": "Défenseur de la nation",
  "hero4": "La Reine Seondeok de Silla",
  "hero4_text": "La Reine Seondeok fut la suzeraine du royaume de Silla, l'un des trois royaumes de Corée, de l'an 632 à l'an 647. Elle fut la première reine à régner sur Silla.",
  "hero4_skill1": "Bienveillante",
  "hero4_skill2": "Vive d’esprit",
  "hero4_skill3": "Conquérante",
  "hero4_skill4": "Amnistie",
  "hero5": "Nobunaga",
  "hero5_text": "Oda Nobunaga (23 juin 1534 – 21 juin 1582) fut le plus influent des daimyō de l'ère Sengoku. Il est considéré comme l'un des trois plus grands unificateurs du Japon féodal, avec ses successeurs Toyotomi Hideyoshi et Tokugawa Ieyasu.",
  "hero5_skill1": "Tenka Fubu",
  "hero5_skill2": "Rempart",
  "hero5_skill3": "Tsubame Gaeshi",
  "hero5_skill4": "Bushido",
  "hero6": "Jeanne d’Arc",
  "hero6_text": "Jeanne d’Arc est considérée comme une sainte protectrice en France. Ayant reçu une inspiration divine, elle transcenda son genre en devenant une cheffe de guerre et sauva la France de la domination anglaise.",
  "hero6_skill1": "Bénédiction des anges",
  "hero6_skill2": "Jeanne",
  "hero6_skill3": "Croyance",
  "hero6_skill4": "Sainte bénédiction",
  "roleMainTitle": "Recrutez des personnages historiques",
  "roleSubTitle": "Game of Empires vous offre l'opportunité de recruter un grand nombre de figures historiques afin d'étendre les frontières de votre empire.",
  "back": "Retour",
  "slogan": "Bâtissez votre empire !",
}
